import api from '../../../api';
import * as types from '../../../redux/actionTypes';
import { loadCredentials } from './userActions';

export function login(returnTo) {
  window.location.assign(`/login?returnTo=${encodeURIComponent(returnTo)}`);
}

export function sessionCheckBegin() {
  return { type: types.SESSION_CHECK_BEGIN };
}

export function sessionCheckSuccess(result) {
  return { type: types.SESSION_CHECK_SUCCESS, result };
}

export function sessionCheckError(error) {
  return { type: types.SESSION_CHECK_FAILED, error };
}

export function initialAuthStateSuccess(result) {
  return { type: types.INITIAL_AUTH_STATE_SUCCESS, result };
}

export function checkSession() {
  return async function (dispatch, getState) {
    const previousAuthState = getState().auth.isAuthenticated;
    dispatch(sessionCheckBegin());
    try {
      const result = await api.auth.getUserInfo();
      dispatch(sessionCheckSuccess(result));
      if (!previousAuthState && result.isAuthenticated) {
        loadCredentials()(dispatch, getState);
      }
    } catch (error) {
      dispatch(sessionCheckError(error));
    }
  };
}

export function setInitialAuthState(authState) {
  return function(dispatch, getState) {
    dispatch(initialAuthStateSuccess(authState));
    if (authState.isAuthenticated) {
      loadCredentials()(dispatch, getState);
    }
  };
}

export function loadAuthenticationStatus(status) {
  return { type: types.LOAD_AUTHENTICATION_STATUS, status };
}

export function loadAuthenticationStatusError(error) {
  return { type: types.LOAD_AUTHENTICATION_STATUS_ERROR, error };
}

